module.exports = __webpack_public_path__ + "img/bottom_flower.870d8432.png";